import React from "react";
import { Popup } from "react-map-gl";
import { statesViews } from "../../constants";
import {
  StyledPopup,
  PopupHeader,
  PopupTitle,
  PopupSubtitle,
  PopupContent,
} from "../Popup/styled";

function StatePopup({ className, data, view, children, ...props }) {
  return (
    <StyledPopup className={className} {...props} as={Popup}>
      <PopupHeader>
        <PopupTitle>{data.name}</PopupTitle>
        <PopupSubtitle>
        </PopupSubtitle>
      </PopupHeader>
      <PopupContent>
        <ul>
          <li>
            <span>State Rank: </span>#
            {view === statesViews.CAPACITY
              ? data.total_solar_school_energy_capacity_rank
              : data.number_solar_schools_rank}
          </li>
          {view === statesViews.CAPACITY ? (
            <li>
              <span>Total Solar Capacity:</span>{" "}
              {data.total_solar_school_energy_capacity.toLocaleString("en-US")}{" "}
              kW
            </li>
          ) : (
            <li>
              <span>Number of Solar Schools:</span>{" "}
              {data.number_solar_schools.toLocaleString("en-US")}
              {/* <span>Number of Schools:</span> {parseFloat(data.number_schools)} */}
            </li>
          )}{" "}
        </ul>
        {/* {data.state_resources && (
          <a href={data.state_resources} target="_blank" rel="noreferrer">
            State Resources
          </a>
        )} */}
      </PopupContent>
    </StyledPopup>
  );
}

export default StatePopup;
